import React, { CSSProperties } from 'react'

export const GraySection: React.FC<{
  className?: string
  style?: CSSProperties
  children?: any
}> = ({ children }) => {
  return <div className="bg-gray-100 py-[5%] lg:py-4">{children}</div>
}
